import PolicyPage from "pages/policies/PolicyPage";
import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";
import { Company } from "types";
import { SelectedCompanyContext } from "utils/context";

export default function PolicyRoutes() {
    const [selectedCompany, setSelectedCompany] = useState<Company>();
    return (
        <SelectedCompanyContext.Provider value={[selectedCompany, setSelectedCompany]}>
            <Routes>
                <Route path="*" element={<PolicyPage />} />
            </Routes>
        </SelectedCompanyContext.Provider>
    );
}
